import { Instagram, Linkedin, Youtube, Facebook } from "lucide-react";
import { SOCIALS } from "../data/site";

const ICONS = { instagram: Instagram, linkedin: Linkedin, youtube: Youtube, facebook: Facebook };

// Social icon row. `variant` controls styling for light/dark surfaces.
export const Socials = ({ variant = "boxDark", showLabel = false, iconSize = "w-4 h-4", className = "" }) => {
  const styles = {
    // bordered boxes on cream/light surface
    boxDark: "border border-dark-text/20 text-dark-text hover:bg-bottle-green hover:text-cream hover:border-bottle-green",
    // bordered boxes on dark (green) surface
    boxLight: "border border-cream/25 text-cream hover:bg-cream hover:text-bottle-green",
    // minimal, for header (light text over dark hero)
    plainLight: "text-cream/80 hover:text-cream",
    // minimal, for header (dark text over cream)
    plainDark: "text-dark-text/70 hover:text-bottle-green",
  };
  const boxed = variant === "boxDark" || variant === "boxLight";
  const labelColor = variant === "plainLight" || variant === "boxLight" ? "text-cream/55" : "text-dark-text/50";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {showLabel && (
        <span className={`font-mono text-[10px] tracking-[0.2em] uppercase ${labelColor}`}>Follow us</span>
      )}
      <div className="flex items-center gap-2">
        {SOCIALS.map((s) => {
          const Icon = ICONS[s.icon];
          return (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              data-testid={`social-${s.icon}`}
              className={`transition-colors duration-300 ${
                boxed ? `w-9 h-9 flex items-center justify-center rounded-sm ${styles[variant]}` : styles[variant]
              }`}
            >
              <Icon className={iconSize} strokeWidth={1.7} />
            </a>
          );
        })}
      </div>
    </div>
  );
};
